export const DOMAIN_REGISTRATION_STATUS_PENDING = 'pending'
export const DOMAIN_REGISTRATION_STATUS_ACTIVE = 'active'
export const DOMAIN_REGISTRATION_STATUS_EXPIRED = 'expired'
export const DOMAIN_REGISTRATION_STATUS_FAILED = 'failed'
